$(function() {
    //caches a jQuery object containing the header element
    var header = $("header");
    $(window).scroll(function() {
        var scroll = $(window).scrollTop();

        if (scroll >= 1) {
            header.addClass("scrolled");
        } else {
            header.removeClass("scrolled");
        }
    });
});


$(".dropdown").hover(function () {
    $("body").toggleClass("disable-scroll");
});


$(".navbar-toggler").click(function(){
  $(this).toggleClass("collapsed");
});


$('.top-bar').slick({ 
  dots: false,
  infinite: true,
  speed: 500,
  fade: true,
  cssEase: 'linear',
  arrows: false,
  autoplay: true
});


  /* Slick needs no get Reinitialized on window Resize after it was destroyed */
    $(window).on('load resize orientationchange', function() {
        $('.product-carousel').each(function(){
            var $carousel = $(this);
            /* Initializes a slick carousel only on mobile screens */
            // slick on mobile
            if ($(window).width() < 1199) {
                if ($carousel.hasClass('slick-initialized')) {
                    $carousel.slick('unslick');
                }
            }
            else{
                if (!$carousel.hasClass('slick-initialized')) {
                    $carousel.slick({
                        dots: false,
                        infinite: false,
                        arrows: true,
                        autoplay: false,
                        slidesToShow: 4,
                        slidesToScroll: 1,
                        centerMode: false,
                        prevArrow:'<button class="slick-prev"><svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.6667 20.4167L16.26 25L17.0104 24.2594L13.6871 20.9433H27.5V19.89H13.6871L17.0104 16.5739L16.26 15.8333L11.6667 20.4167Z" fill="#333333"/><circle cx="20" cy="20" r="19.5" transform="matrix(-1 0 0 1 40 0)" stroke="#333333"/></svg></button>',
                        nextArrow:'<button class="slick-next"><svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M28.3333 19.5833L23.74 15L22.9896 15.7406L26.3129 19.0567L12.5 19.0567L12.5 20.11L26.3129 20.11L22.9896 23.4261L23.74 24.1667L28.3333 19.5833Z" fill="#333333"/><circle cx="20" cy="20" r="19.5" transform="matrix(1 1.74846e-07 1.74846e-07 -1 0 40)" stroke="#333333"/></svg></button>'
                    });
                }
            }
        });
    });

    /* Refresh Slick when showing slider placed on hidden elements */
$('#myTab button[data-bs-toggle="tab"]').on('shown.bs.tab', event => {
    let targetPaneID = $(event.target).data('bs-target')
    $(targetPaneID + ' .product-carousel').slick("refresh");
})

      /* Slick needs no get Reinitialized on window Resize after it was destroyed */
    $(window).on('load resize orientationchange', function() {
        $('.news-carousel').each(function(){
            var $carousel = $(this);
            /* Initializes a slick carousel only on mobile screens */
            // slick on mobile
            if ($(window).width() < 1199) {
                if ($carousel.hasClass('slick-initialized')) {
                    $carousel.slick('unslick');
                }
            }
            else{
                if (!$carousel.hasClass('slick-initialized')) {
                    $carousel.slick({
                        dots: false,
                        infinite: false,
                        arrows: true,
                        autoplay: false,
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        centerMode: false,
                    });
                }
            }
        });
    });

            /* Slick needs no get Reinitialized on window Resize after it was destroyed */
    $(window).on('load resize orientationchange', function() {
        $('.image-carousel').each(function(){
            var $carousel = $(this);
            /* Initializes a slick carousel only on mobile screens */
            // slick on mobile
            if ($(window).width() < 1199) {
                if ($carousel.hasClass('slick-initialized')) {
                    $carousel.slick('unslick');
                }
            }
            else{
                if (!$carousel.hasClass('slick-initialized')) {
                    $carousel.slick({
                        infinite: true,
                        variableWidth: true,
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        arrows: true,
                        fade: false,
                    });
                }
            }
        });
    });



        /* Slick needs no get Reinitialized on window Resize after it was destroyed */
    $(window).on('load resize orientationchange', function() {
        $('.slider-for').each(function(){
            var $carousel = $(this);
            /* Initializes a slick carousel only on mobile screens */
            // slick on mobile
            if ($(window).width() < 92) {
                if ($carousel.hasClass('slick-initialized')) {
                    $carousel.slick('unslick');
                }
            }
            else{
                if (!$carousel.hasClass('slick-initialized')) {
                    $carousel.slick({
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: true,
                        fade: true,
                        asNavFor: '.slider-nav',
                        responsive: [
                            {
                                breakpoint: 991,
                                settings: {
                                    dots: true,
                                    arrows: false
                                }
                            }
                        ]
                    });
                }
            }
        });
    });


    $('.slider-nav').slick({
        slidesToShow: 6,
        slidesToScroll: 1,
        vertical:true,
        asNavFor: '.slider-for',
        dots: false,
        focusOnSelect: true,
        verticalSwiping:true,
        arrows: false
    });




    /* Slick needs no get Reinitialized on window Resize after it was destroyed */
    $(window).on('load resize orientationchange', function() {
        $('.up-sell').each(function(){
            var $carousel = $(this);
            /* Initializes a slick carousel only on mobile screens */
            // slick on mobile
            if ($(window).width() < 1199) {
                if ($carousel.hasClass('slick-initialized')) {
                    $carousel.slick('unslick');
                }
            }
            else{
                if (!$carousel.hasClass('slick-initialized')) {
                    $carousel.slick({
                        dots: false,
                        infinite: false,
                        arrows: true,
                        autoplay: false,
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        centerMode: false
                    });
                }
            }
        });
    });


    $('.simple-carousel').slick({ 
      dots: false,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,

    });



// Prepend back button to sub menu(s)
//$('.nav__sub').prepend('<li class="nav-item"><a class="nav-link sub__close" href="#"> Back</a></li>');

  // Close out sub menu
  $('.sub__close').click(function(e) {
    e.preventDefault();
    
    $(this).parent().parent().removeClass('is-active');
  });

  // Trigger sub menu
  $('.have-sub-menu > .nav-link').click(function(e) {
    e.preventDefault();
    
    $(this).siblings().addClass('is-active');
    $('.offcanvas-start').addClass('bg-0');
     
  });

  $('.btn-wishlist').on("click", function() {
        $(this).toggleClass('added');
    });

    $('.open-form').click(function(e) {
    $('.addresses-form').toggleClass('hide'); 
  });


$('#collapseGiftMessage').on('show.bs.collapse', () => {
   $('#offcanvasBag').addClass('background-collpase');
})
$('#collapseGiftMessage').on('hide.bs.collapse', () => {
   $('#offcanvasBag').removeClass('background-collpase');
})

const btn = document.getElementById("readmore")
if (btn != undefined) {
  btn.addEventListener('click', () => {
    btn.textContent = btn.textContent === "- Read less" ? "+ Read more" : "- Read less";
  })
}


$('.js-show-mobile-variants').on('click', function() {
  $(this).closest('.product-item').addClass('show-mobile-variants');
});

$(document).on('click', function(event) {
  if (!$(event.target).closest('.product-item').length) {
    $('.product-item').removeClass('show-mobile-variants');
  }
});

$('.js-close-mobile-variants').on('click', function(event) {
  event.stopPropagation();
  $(this).closest('.product-item').removeClass('show-mobile-variants');
});
